/**
 * @type {Record<string, string[]>}
 */
const restrictedRoutes = {
    "/settings": ["settings"],
    "/email-config": ["settings"],
    "/settings/app-integrations": ["settings"],
    "/settings/app-integrations/shopify": ["settings"],
    "/facebook-config": ["settings"],
    "/settings/ads-integrations": ["settings"],
    "/settings/customfields": ["settings"],
    "/settings/customfieldscreation": ["settings"],
    "/addnewuser": ["settings"],
    "/settings/inactive": ["settings"],
    "/settings/sms-settings": ["settings"],
    "/settings/cart-abandon": ["settings"],
    "/settings/configure-engagement": ["settings"],
};

export default restrictedRoutes;
